import React from 'react';

import { getReferral } from '../../util/server-util';

export default function HiddenReferral() {
  const referral = getReferral();
  return referral ? <input type='hidden' name='referral' value={referral} /> : null;
}
